import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { AccountChildrenButtonAccountFragmentDoc } from './AccountChildrenButton.generated'
import { AccountInfoButtonAccountFragmentDoc } from './AccountInfoButton.generated'
import { AccountMoreOptionsMenuAccountFragmentDoc } from './AccountMoreOptionsMenu.generated'
import * as Types from './purchasePlus_graphql'

export const AccountCodesTableViewAccountFragmentDoc = gql`
  fragment AccountCodesTableViewAccount on Account {
    id
    name
    code
    description
    parent {
      id
      name
      code
    }
    ...AccountChildrenButtonAccount
    ...AccountInfoButtonAccount
    ...AccountMoreOptionsMenuAccount
  }
  ${AccountChildrenButtonAccountFragmentDoc}
  ${AccountInfoButtonAccountFragmentDoc}
  ${AccountMoreOptionsMenuAccountFragmentDoc}
` as unknown as DocumentNode<Types.AccountCodesTableViewAccountFragment, unknown>
